import type { ReactNode } from "react";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

type LayoutProps = {
  children: ReactNode;
  fullWidth?: boolean;
};

export function Layout({ children, fullWidth = false }: LayoutProps) {
  return (
    <div className="app-shell">
      <Header />
      <div className={fullWidth ? "page-grid page-grid--wide" : "page-grid"}>
        <Sidebar />
        <main id="main-content" className="main-content" tabIndex={-1}>
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
}
